// extracted by mini-css-extract-plugin
export default {"app":"App__app___a_ROV","axis_title":"App__axis_title___DmZKt"};